import { render, staticRenderFns } from "./PaymentDetailsPDF.vue?vue&type=template&id=63e72ea2"
import script from "./PaymentDetailsPDF.vue?vue&type=script&lang=js"
export * from "./PaymentDetailsPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports